import { render } from "./ViewEmployee.vue?vue&type=template&id=bc1350fa&scoped=true"
import script from "./ViewEmployee.vue?vue&type=script&lang=js"
export * from "./ViewEmployee.vue?vue&type=script&lang=js"

import "./ViewEmployee.vue?vue&type=style&index=0&id=bc1350fa&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1350fa"]])

export default __exports__